<template>
    <div ref="scene-logo-container" class="scene-logo-container">
        
    </div>
</template>

<script>

// Components

// Scene
import SceneLogo from '../../helpers/threejs/scenes/SceneLogo'
import MyEmitter from '../../helpers/MyEmitter'
import params from '../../utils/params'
import gsap from 'gsap'

export default {

    name: "SceneLogoContainer",

    // Router

    beforeDestroy: function(){
        MyEmitter.off(params.Events.logoGoHeaderMobile, this.animateHeaderUpMobile)
        MyEmitter.off(params.Events.logoGoHeader, this.animateHeaderUp)

        MyEmitter.off(params.Events.logoGoMiddle, this.animateHeaderDown)
        MyEmitter.off(params.Events.logoGoMiddleMobile, this.animateHeaderDownMobile)

    },
    mounted: function(){

        console.log("moutned scene logo cont")

        // Events
        MyEmitter.on(params.Events.logoGoHeaderMobile, this.animateHeaderUpMobile)
        MyEmitter.on(params.Events.logoGoHeader, this.animateHeaderUp)

        MyEmitter.on(params.Events.logoGoMiddle, this.animateHeaderDown)
        MyEmitter.on(params.Events.logoGoMiddleMobile, this.animateHeaderDownMobile)

        // Start scene
        this.sceneLogo = new SceneLogo(this.$refs["scene-logo-container"], {
            rendererAlpha: true,
            premultipliedAlpha: false
        }, {
            startAt: this.$route.name,
            navItems: this.$el.querySelectorAll(".js-nav-item"),
            isMobile: true
        })
        this.sceneLogo.init()
        this.sceneLogo.start()
    },

    methods: {

        animateHeaderUpMobile: function(duration){

            gsap.to(this.$el, {
                duration: duration,
                y: "-100%"
            })
            
        },

        animateHeaderDownMobile: function(duration){

            gsap.fromTo(this.$el, {
                opacity: 0,
            }, {
                duration: duration,
                onStart: () => {

                    if(this.sceneLogo._logoMode === "header"){
                        this.sceneLogo._animateToMiddleState()
                    }

                    gsap.to(this.$el, {
                        duration: 0,
                        y: 0
                    })
                },

                opacity: 1,
            })

            
        },

        animateHeaderUp: function(justMove = false, onComplete = null, isMobile = false){

            if(this.sceneLogo._logoMode === "header") {
                onComplete && onComplete()
                return;
            }

            if(!justMove) this.sceneLogo._animateToHeaderState(isMobile, onComplete)
        },

        animateHeaderDown: function(onComplete){

            if(this.sceneLogo._logoMode === "middle") {
                onComplete && onComplete()
                return;
            }

            this.sceneLogo._animateToMiddleState()

            onComplete && onComplete()
        },

        onMouseEnterLogo: function(){
            this.sceneLogo && this.sceneLogo._onMouseEnterLogo()
        },
    }
}
</script>

<style lang="scss">
    .scene-logo-container{
        @include absolute-fullscreen();
        position: fixed;
        width: 100vw;
        height: 100%;
        pointer-events: none;
        z-index: 21;
    }
</style>